import {
	BaseError,
} from './BaseError';

export class PostSpecificationAcceptedUpdatedOfferError extends BaseError {
	constructor(message: string, stack?: string) {
		super(message, stack);
	}
}
